module.exports = __webpack_public_path__ + "img/climate_actions_ebike.a01a4d2.svg";